import Backbone from 'backbone'
import PurchasedModel from '../models/purchase'
import Request from '../helpers/request'
import user from '../user'
import config from '../config'

const PurchasedList = Backbone.Collection.extend({
    model: PurchasedModel,
    purchased(app_id) {
        // if the array is empty return false else true
        const id = app_id || config.get('id')
        const searchResult = this.where({_id: id})
        return searchResult.length !== 0
    },
    addPromo(code) {
        let api = '/api/me/promocode/activate'

        if (this.parent.get('uid') !== user.get('uid')) {
            api = '/api/school/student/' + this.parent.get('id') + '/promocode'
        }

        if (code) {
            // check code
            return Request({
                url: api,
                method: 'PUT',
                data: {
                    code: code,
                },
            })
                .then((response) => {
                    // add purchase to app
                    this.add({_id: response.promocode.appId})
                    return this.parent.localSave()
                })
        }
    },
    addPurchase(transactionId) {
        return Request({
            url: '/api/me/promocode/generate',
            method: 'POST',
            data: {
                transactionId: transactionId,
            },
        })
            .then((response) => {
                // add purchase to app
                this.add({_id: response.promocode.appId})
                return this.parent.localSave()
            })
    },
    decorate() {
        // replace the app name with the config's app name
        return this.map(model => {
            const item = model.toJSON()
            const app = config.get('apps').find(app => app.id === item._id)
            if (app) {
                return { ...item, name: app.name }
            }
            return item
        })
    }
})

export default PurchasedList
